import {Component,  OnInit} from '@angular/core';
import {CartService} from "../services/cart.service";
import {Router, RouterLink, RouterLinkActive} from "@angular/router";
import {AuthService} from "../services/auth.service";
import {faEnvelope, faHeart, faShoppingCart, faUser} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {CommonModule, NgForOf, NgIf} from "@angular/common";
import {LoginComponent} from "../login/login.component";
import {RegisterComponent} from "../register/register.component";
import {AuthModalService} from "../services/auth.modal.service";

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    imports: [
        CommonModule,
        RouterLink,
        RouterLinkActive,
        FontAwesomeModule,
        NgIf,
        NgForOf
    ],
    standalone: true
})
export class NavbarComponent implements OnInit {

    cartCount: number = 0;
    isLoggedIn: boolean = this.authService.isLoggedIn();
    isMenuOpen = false;
    protected isAdmin = this.authService.isAdmin();
    openSection: string | null = null;
    protected readonly faShoppingCart = faShoppingCart;
    protected readonly faEnvelope = faEnvelope;
    protected readonly faHeart = faHeart;
    protected readonly faUser = faUser;

    constructor(private cartService: CartService,
                private router: Router,
                private authModalService: AuthModalService,
                private authService: AuthService) {
    }

    toggleSection(section: string) {
        this.openSection =
            this.openSection === section ? null : section;
    }

    combos = [{id: 'c3699a7c-42fb-4e73-9bdd-aa3a9f1d0a64', name: '1. Pigmentation & Melasma Removal'},
        {
            id: 'b1b12d6b-1c47-43f5-863a-5954f421c112',
            name: '2. Skin Tightening & Anti Aging, pigmentation, dark spots, Tan removal'
        },
        {id: '86914c3a-c14c-4195-9d26-30c680e23bb6', name: '3. Underarm Whitening & Black Thigh Removal'},
        {id: 'b5de04c4-a3e6-4567-906d-f2c9237aae22', name: '4. Hair Fall, Dandruff & Hair Problem'},
        {id: 'd8ab3dec-5058-496e-9f32-5bf8e5659ca8', name: '5. Pigmentation, Dark Spot, Dark Circle, Tan Removal'},
        {id: '2bb5825a-1001-4baa-b229-bb6a64932c8d', name: '6. Face Whitening, Dark Spot & Oily Skin Glow'},
        {id: '88081b52-93ef-4c2b-b29e-c1f704323e6f', name: '7. Acne Spot & Small Pimples'},
        {id: '667be418-33af-4a96-8038-647ff01eccba', name: '8. Large & Big Pimple Pustules'},
        {id: 'b13b6381-7ca3-4811-a0e8-474589780187', name: '9. Dark Spot, Pimples & Pores'},
        {id: '21ab78ea-ab79-47d4-bcb2-ac560e74cd19', name: '10. Pores Removal Kit'},
        {id: '88d42219-03b2-4a70-a43c-19bc8c719c7f', name: '11. Pigmentation, dark spot, dark Circle, dry skin'},
        {id: 'dc1a5f4e-dace-4436-9eea-19159daa5c3b', name: '12. Body Whitening & Body Tan Removal'}
    ];

    ngOnInit() {
        this.cartService.cartCount$.subscribe(count => {
            this.cartCount = count;
        });
    }

    navLogin() {
        this.isMenuOpen = !this.isMenuOpen;
        this.switchToLogin();
    }

    triggerLogin() {
        this.authService.isLoggedIn() ? this.router.navigate(['/account']) : this.switchToLogin();
    }

    toggleMenu() {
        this.isMenuOpen = !this.isMenuOpen;
        // Close login/register if menu opens
        if (this.isMenuOpen) {
            this.authModalService.closeLogin();
        }
    }

    switchToLogin() {
        this.authModalService.openLogin();
    }

}